import MediaDetail from './MediaDetail.container';

export default MediaDetail;
